import { $, bindClick } from "../lib/dom.js";
import { escHtml } from "../lib/hints.js";
import { loadRegionNames, regionLabelList } from "../lib/geo-names.js";
import { api, apiBase } from "../api.js";

function notify(text, ok) {
  const el = $("key-banner");
  if (!el) return;
  el.textContent = text;
  el.classList.toggle("hidden", !text);
  el.classList.toggle("ok", !!ok);
}

/** 「名称（id）」—— 名称由后端 join 带出，取不到就只留 id。 */
function namedLabel(name, id) {
  const n = String(name || "").trim();
  const i = String(id || "").trim();
  if (!i) return "";
  return n ? `${escHtml(n)}（${escHtml(i)}）` : escHtml(i);
}

function renderApplications(items) {
  const box = $("cr-channel-apps");
  if (!box) return;
  if (!items.length) {
    box.innerHTML = "<p class='mc-desc'>暂无待审经销申请。</p>";
    return;
  }
  box.innerHTML = items
    .map((app) => {
      const contact = app.applicant_contact || {};
      const regions = regionLabelList(app.apply_region_codes);
      return `<div class="os-app-card">
        <div><strong>${namedLabel(app.brand_name, app.brand_id)}</strong> · ${namedLabel(
          app.applicant_merchant_name,
          app.applicant_merchant_id
        )}</div>
        <div class="mc-desc">落点门店：${namedLabel(app.applicant_store_name, app.applicant_store_id) || "未指定（通过时可指定）"}</div>
        <div class="mc-desc">区域：${escHtml(regions || "—")}</div>
        <div class="mc-desc">联系：${escHtml(contact.cs_contact || contact.contact_phone || "—")}</div>
        <div class="mc-actions">
          <button type="button" class="secondary cr-app-approve" data-id="${escHtml(app.application_id)}">通过</button>
          <button type="button" class="secondary cr-app-reject" data-id="${escHtml(app.application_id)}">拒绝</button>
        </div>
      </div>`;
    })
    .join("");
  box.querySelectorAll(".cr-app-approve").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const id = btn.getAttribute("data-id");
      const { ok, data } = await api(
        "POST",
        `/api/v1/fitting/mall/channel-applications/${encodeURIComponent(id)}/approve`,
        { body: {} }
      );
      notify(ok ? "已通过（仅经营关系）" : (data && data.message) || "审批失败", !!ok);
      if (ok) await loadChannelReviewsPanel();
    });
  });
  box.querySelectorAll(".cr-app-reject").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const id = btn.getAttribute("data-id");
      const reason = window.prompt("驳回原因", "") || "";
      if (!reason.trim()) return;
      const { ok, data } = await api(
        "POST",
        `/api/v1/fitting/mall/channel-applications/${encodeURIComponent(id)}/reject`,
        { body: { reject_reason: reason.trim() } }
      );
      notify(ok ? "已驳回" : (data && data.message) || "驳回失败", !!ok);
      if (ok) await loadChannelReviewsPanel();
    });
  });
}

/** 我自己发出去的邀请：等下游确认，未确认前只能撤回（对面才是决定方）。 */
function renderInvites(items) {
  const box = $("cr-channel-invites");
  if (!box) return;
  if (!items.length) {
    box.innerHTML = "<p class='mc-desc'>暂无待确认的邀请。</p>";
    return;
  }
  box.innerHTML = items
    .map((app) => {
      const regions = regionLabelList(app.apply_region_codes);
      return `<div class="os-app-card">
        <div><strong>${namedLabel(app.brand_name, app.brand_id)}</strong> · 邀请 ${namedLabel(
          app.applicant_merchant_name,
          app.applicant_merchant_id
        )}</div>
        <div class="mc-desc">落点门店：${namedLabel(app.applicant_store_name, app.applicant_store_id) || "—"}</div>
        <div class="mc-desc">经销区域：${escHtml(regions || "—")}</div>
        <div class="mc-actions">
          <button type="button" class="secondary cr-invite-withdraw" data-id="${escHtml(app.application_id)}">撤回邀请</button>
        </div>
      </div>`;
    })
    .join("");
  box.querySelectorAll(".cr-invite-withdraw").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const id = btn.getAttribute("data-id");
      if (!window.confirm("撤回后该邀请作废，对方不再需要处理。确定撤回？")) return;
      const { ok, data } = await api(
        "POST",
        `/api/v1/fitting/mall/channel-applications/${encodeURIComponent(id)}/withdraw`,
        { body: {} }
      );
      notify(ok ? "邀请已撤回" : (data && data.message) || "撤回失败", !!ok);
      if (ok) await loadChannelReviewsPanel();
    });
  });
}

export async function loadChannelReviewsPanel() {
  // 两个方向分开取，不靠 role 隐式排 —— `initiated_by` 必须显式写：
  // 不写的话「待审申请」里会混进我自己发出去的邀请，还带上「通过/拒绝」按钮，
  // 等于让我自己批自己发的邀请。
  const [incoming, outgoing] = await Promise.all([
    api(
      "GET",
      "/api/v1/fitting/mall/channel-applications?role=manager&status=pending&initiated_by=applicant"
    ),
    api(
      "GET",
      "/api/v1/fitting/mall/channel-applications?role=manager&status=pending&initiated_by=manager"
    ),
  ]);
  const incomingItems = (incoming.ok && incoming.data && incoming.data.items) || [];
  const outgoingItems = (outgoing.ok && outgoing.data && outgoing.data.items) || [];
  // 经销区域是 adcode，换成人话再渲染（render 是同步的，名字得先备好）
  const codes = [];
  incomingItems.concat(outgoingItems).forEach((it) =>
    (it.apply_region_codes || []).forEach((c) => codes.push(c))
  );
  await loadRegionNames(apiBase(), codes);
  renderApplications(incomingItems);
  renderInvites(outgoingItems);
}

export function initChannelReviewsHandlers() {
  bindClick("btn-cr-refresh", () => loadChannelReviewsPanel());
}
